// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var AutocompleteV5 = require("../autocomplete/AutocompleteV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function roleToString(x) {
  switch (x) {
    case "ASSISTANT" :
        return "Assistant";
    case "ASSOCIATE" :
        return "Associate";
    case "BUYER_SPECIALIST" :
        return "Buyer Specialist";
    case "CLIENT_CARE_COORDINATOR" :
        return "Client Care Coordinator";
    case "INSIDE_SALES_AGENT" :
        return "Inside Sales Agent";
    case "LISTING_MANAGER" :
        return "Listing Manager";
    case "LISTING_SPECIALIST" :
        return "Listing Specialist";
    case "MARKETING_SPECIALIST" :
        return "Marketing Specialist";
    case "OPERATIONS_MANAGER" :
        return "Operations Manager";
    case "OWNER" :
        return "Owner";
    case "PARTNER" :
        return "Partner";
    case "SHOWING_ASSISTANT" :
        return "Showing Assistant";
    case "TRANSACTION_COORDINATOR" :
        return "Transaction Coordinator";
    case "UNKNOWN" :
        return "Unknown";
    
  }
}

function roleInputToString(x) {
  return roleToString(x);
}

function getOptionLabel(x) {
  return x.label;
}

function getOptionValue(x) {
  return roleToString(x.value);
}

function make(value) {
  return {
          value: value,
          label: roleToString(value)
        };
}

var defaultValues = [
  "ASSISTANT",
  "ASSOCIATE",
  "BUYER_SPECIALIST",
  "CLIENT_CARE_COORDINATOR",
  "INSIDE_SALES_AGENT",
  "LISTING_MANAGER",
  "LISTING_SPECIALIST",
  "MARKETING_SPECIALIST",
  "OPERATIONS_MANAGER",
  "PARTNER",
  "SHOWING_ASSISTANT",
  "TRANSACTION_COORDINATOR"
];

var options = defaultValues.map(function (v) {
      return make(v);
    });

var SelectOpts = {
  getOptionLabel: getOptionLabel,
  getOptionValue: getOptionValue,
  make: make,
  defaultValues: defaultValues,
  options: options
};

function AccountMemberUtils$RoleSelectComponent(props) {
  var result = props.result;
  return JsxRuntime.jsx(AutocompleteV5.Select.Single.make, {
              getOptionLabel: getOptionLabel,
              getOptionValue: getOptionValue,
              onChange: props.onChange,
              options: options,
              value: props.value,
              status: result !== undefined ? (
                  result === "Error" ? "Failure" : "Success"
                ) : "Neutral"
            });
}

var RoleSelectComponent = {
  make: AccountMemberUtils$RoleSelectComponent
};

exports.roleToString = roleToString;
exports.roleInputToString = roleInputToString;
exports.SelectOpts = SelectOpts;
exports.RoleSelectComponent = RoleSelectComponent;
/* options Not a pure module */
